export default [
  ...require("@/app/auth/routes").default,
  ...require("@/app/dashboard/routes").default,
  ...require("@/app/accounts/routes").default,
  //   ...require("@/app/globalFees/feesTypes/routes").default,
  //   ...require("@/app/globalFees/offers/routes").default,
  ...require("@/app/bulkTransfers/routes").default,
  ...require("@/app/escrowTransfers/routes").default,
  ...require("@/app/platformConfigurations/routes").default,
  //   ...require("@/app/feeConfigurations/routes").default,
  ...require("@/app/feeConfigurations/deposits/routes").default,
  ...require("@/app/feeConfigurations/instantTransfers/routes").default,
  ...require("@/app/feeConfigurations/withdraws/routes").default,
  ...require("@/app/platformConfigurations/transactionCountries/routes").default,
  ...require("@/app/platformConfigurations/receivingCountries/routes").default,
  ...require("@/app/platformConfigurations/paymentProviders/routes").default,
  ...require("@/app/platformConfigurations/cashInMethods/routes").default,
  ...require("@/app/platformConfigurations/cashoutMethods/routes").default,
  ...require("@/app/platformConfigurations/roles/routes").default,
  ...require("@/app/platformConfigurations/individualActivities/routes").default,
  ...require("@/app/platformConfigurations/currencies/routes").default,
  ...require("@/app/cryptoConfigurations/transactionCountries/routes").default,
  ...require("@/app/cryptoConfigurations/routes").default,
  ...require("@/app/cryptoConfigurations/paymentProviders/routes").default,
  ...require("@/app/cryptoConfigurations/cashInMethods/routes").default,
  ...require("@/app/cryptoConfigurations/cashoutMethods/routes").default,
  ...require("@/app/users/routes").default,
  ...require("@/app/influencers/routes").default,
  ...require("@/app/campaigns/routes").default,
  ...require("@/app/crypto/routes").default,
  ...require("@/app/transactions/cashouts/routes").default,
  ...require("@/app/payins/routes").default,
  ...require("@/app/mergeTransfers/routes").default,
  ...require("@/app/transactions/customerRewards/routes").default,
  ...require("@/app/transfers/routes").default,
  ...require("@/app/companies/routes").default,
  ...require("@/app/earningStructure/routes").default,
  ...require("@/app/cloudBanking/routes").default,
  ...require("@/app/criminalCases/routes").default,
];
